import { PartnerProfileStatuses } from '@trnsact/trnsact-shared-types';
import { PartnerProfileStatusBubble } from 'modules/aftermarket/partner/ui/components';
import { formatCurrency } from 'utils';

export const dealerInfoRowsConfig: {
  label: string;
  metricsKey: string;
  component?: (value: any) => JSX.Element;
  formatter?: (value: any, formatZero?: boolean) => string;
}[] = [
  {
    label: 'Status',
    metricsKey: 'status',
    component: (status: PartnerProfileStatuses) => <PartnerProfileStatusBubble status={status} />,
  },
  {
    label: 'Active Menus',
    metricsKey: 'activeMenus',
  },
  {
    label: 'Recent Quotes',
    metricsKey: 'totalSent',
  },
  {
    label: 'Recent Contracts',
    metricsKey: 'totalSold',
  },
  {
    label: 'Sold Volume',
    metricsKey: 'soldRetailPrice',
    formatter: formatCurrency,
  },
];
